import { Stack } from '@mantine/core';
import { useStrategyStore } from '../../../../store/strategy-store/strategy-store';
import { View } from '../../../../store/strategy-store/strategy-store.type';
import { MainSectionControls } from './main-section-controls';
import { MainSectionTable } from './main-section-table';
import { MainSectionTreeMap } from './tree-map/tree-map';

type Props = {
  isLoading: boolean;
};

export const MainSection = ({ isLoading }: Props) => {
  const activeView = useStrategyStore((state) => state.view);

  return (
    <Stack h="100%" style={{ overflow: 'hidden' }} gap="xs">
      <MainSectionControls />
      {activeView === View.Table && <MainSectionTable />}
      {activeView === View.TreeMap && <MainSectionTreeMap isLoading={isLoading} />}
    </Stack>
  );
};
